export function validateCountryPayload(payload) {
  if (!payload?.name?.trim()) {
    return "El nombre es obligatorio.";
  }

  if (!payload?.code?.trim()) {
    return "El codigo es obligatorio.";
  }

  return null;
}
